// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subIndicatorItem--RATpJ {
  position: relative;
  font-size: 15px;
  display: flex;
  align-items: center;
  -moz-column-gap: 4px;
       column-gap: 4px;
  row-gap: 0;
  flex-wrap: wrap;
}[dir] .subIndicatorItem--RATpJ {
  padding: 5px 0 0 0;
}[dir=ltr] .subIndicatorItem--RATpJ {
  margin-right: 0;
}[dir=rtl] .subIndicatorItem--RATpJ {
  margin-left: 0;
}

.subIndicatorItem--RATpJ > ul {
  flex-basis: 100%;
}

.subIndicatorItemSelected--AgSWP {
  font-weight: 700;
}

.subIndicatorItem--RATpJ::before {
  content: '';
  position: absolute;
  top: 20px;
  width: 14px;
  height: 2px;
}

[dir] .subIndicatorItem--RATpJ::before {
  background: var(--tree-color, rgba(0, 0, 0, 0.2));
}

[dir=ltr] .subIndicatorItem--RATpJ::before {
  left: -14px;
}

[dir=rtl] .subIndicatorItem--RATpJ::before {
  right: -14px;
}

.subIndicatorItem--RATpJ:last-child::after {
  content: '';
  position: absolute;
  top: 22px;
  bottom: -2px;
  width: 4px;
}

[dir] .subIndicatorItem--RATpJ:last-child::after {
  background: var(--tree-mask-bg, #f5f5f5);
}

[dir=ltr] .subIndicatorItem--RATpJ:last-child::after {
  left: -14px;
}

[dir=rtl] .subIndicatorItem--RATpJ:last-child::after {
  right: -14px;
}

.subjectName--PE9TP {
  color: #000 !important;
  font-family: museo-sans;
  font-size: 15px;
  font-weight: 300;
  font-style: italic;
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

[dir] .subjectName--PE9TP {
  cursor: pointer;
  border: 1px solid #c3c3c3;
  border-radius: 4px;
  padding: 5px 8px;
  background: white;
}

.selected--rgK6_ {
  font-weight: 700;
}

[dir] .selected--rgK6_ {
  background: rgba(var(--selected_color), 0.25) !important;
  border: 1px solid rgb(var(--selected_color)) !important;
}

.expandButton--HTuQw {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
}

[dir] .expandButton--HTuQw {
  border-radius: 0;
  cursor: pointer;
  border: none;
  padding: 0 0 1px 0;
  background: transparent;
}

.expandButton--HTuQw:hover {
  opacity: 0.7;
}

.expandButtonActive--PxtRQ {
  color: #fff;
}

[dir] .expandButtonActive--PxtRQ {
  background: rgb(var(--selected_color));
  border-radius: 50%;
}

.subIndicatorsTree--sBarZ {
  --tree-color: rgba(0, 0, 0, 0.2);
  --tree-mask-bg: #f5f5f5;
}

[dir=ltr] .subIndicatorsTree--sBarZ {
  border-left: 2px solid rgba(0, 0, 0, 0.2);
  margin-left: 8px;
  padding-left: 12px;
}

[dir=rtl] .subIndicatorsTree--sBarZ {
  border-right: 2px solid rgba(0, 0, 0, 0.2);
  margin-right: 8px;
  padding-right: 12px;
}

.appMenuLevel4Expand--d86Wg {
  flex-shrink: 0;
}

[dir] .appMenuLevel4Expand--d86Wg {
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/SubIndicators/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EAGf,aAAa;EACb,mBAAmB;EACnB,oBAAe;OAAf,eAAe;EACf,UAAU;EACV,eAAe;AACjB,CAVA;EAGE,kBAAkB;AAOpB,CAVA;EAIE,eAAe;AAMjB,CAVA;EAIE,cAAe;AAMjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,SAAS;EACT,WAAW;EACX,WAAW;AAEb;;AARA;EAOE,iDAAiD;AACnD;;AARA;EAGE,WAAW;AAKb;;AARA;EAGE,YAAW;AAKb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,SAAS;EACT,YAAY;EACZ,UAAU;AAEZ;;AARA;EAOE,wCAAwC;AAC1C;;AARA;EAGE,WAAW;AAKb;;AARA;EAGE,YAAW;AAKb;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAEhB,kBAAkB;EAIlB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EAER,OAAO;AACT;;AAfA;EAKE,eAAe;EAEf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAIhB,iBAAiB;AAEnB;;AAEA;EACE,gBAAgB;AAGlB;;AAJA;EAEE,wDAAwD;EACxD,uDAAuD;AACzD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EAEZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAGhB,cAAc;AAGhB;;AAfA;EAME,gBAAgB;EAIhB,eAAe;EACf,YAAY;EAEZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,WAAW;AAEb;;AAJA;EACE,sCAAsC;EAEtC,kBAAkB;AACpB;;AAEA;EAIE,gCAAgC;EAChC,uBAAuB;AACzB;;AANA;EACE,yCAAyC;EACzC,gBAAgB;EAChB,kBAAkB;AAGpB;;AANA;EACE,0CAAyC;EACzC,iBAAgB;EAChB,mBAAkB;AAGpB;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,SAAS;AAEX","sourcesContent":[".subIndicatorItem {\n  position: relative;\n  font-size: 15px;\n  padding: 5px 0 0 0;\n  margin-right: 0;\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n  row-gap: 0;\n  flex-wrap: wrap;\n}\n\n.subIndicatorItem > ul {\n  flex-basis: 100%;\n}\n\n.subIndicatorItemSelected {\n  font-weight: 700;\n}\n\n.subIndicatorItem::before {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 20px;\n  width: 14px;\n  height: 2px;\n  background: var(--tree-color, rgba(0, 0, 0, 0.2));\n}\n\n.subIndicatorItem:last-child::after {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 22px;\n  bottom: -2px;\n  width: 4px;\n  background: var(--tree-mask-bg, #f5f5f5);\n}\n\n.subjectName {\n  color: #000 !important;\n  font-family: museo-sans;\n  font-size: 15px;\n  font-weight: 300;\n  cursor: pointer;\n  font-style: italic;\n  border: 1px solid #c3c3c3;\n  border-radius: 4px;\n  padding: 5px 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: white;\n  flex: 1;\n}\n\n.selected {\n  font-weight: 700;\n  background: rgba(var(--selected_color), 0.25) !important;\n  border: 1px solid rgb(var(--selected_color)) !important;\n}\n\n.expandButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 0;\n  color: #000;\n  font-size: 18px;\n  font-weight: 300;\n  cursor: pointer;\n  border: none;\n  line-height: 1;\n  padding: 0 0 1px 0;\n  background: transparent;\n}\n\n.expandButton:hover {\n  opacity: 0.7;\n}\n\n.expandButtonActive {\n  background: rgb(var(--selected_color));\n  color: #fff;\n  border-radius: 50%;\n}\n\n.subIndicatorsTree {\n  border-left: 2px solid rgba(0, 0, 0, 0.2);\n  margin-left: 8px;\n  padding-left: 12px;\n  --tree-color: rgba(0, 0, 0, 0.2);\n  --tree-mask-bg: #f5f5f5;\n}\n\n.appMenuLevel4Expand {\n  margin: 0;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"subIndicatorItem": `subIndicatorItem--RATpJ`,
	"subIndicatorItemSelected": `subIndicatorItemSelected--AgSWP`,
	"subjectName": `subjectName--PE9TP`,
	"selected": `selected--rgK6_`,
	"expandButton": `expandButton--HTuQw`,
	"expandButtonActive": `expandButtonActive--PxtRQ`,
	"subIndicatorsTree": `subIndicatorsTree--sBarZ`,
	"appMenuLevel4Expand": `appMenuLevel4Expand--d86Wg`
};
export default ___CSS_LOADER_EXPORT___;
